// VerseClick 2.5
// Copyright 2018 StudyLamp Software LLC.
// https://av1611.com/verseclick
// ALL RIGHTS RESERVED.  See website above for terms of use.
// Modification expressly prohibited.  This is copyrighted material.
var VERSECLICK = {};
var vcjl = "https://av1611.com/verseclick/";
VERSECLICK.LoadBibleData = function(vclj1) {
    var vclji = document.getElementById(vclj1);
    var vcljl = vclj1.replace(/VCSCRIPTURE_/i, "");
    vcljl = vcljl.replace(/_/g, " ");
    if (vclji && vcljl && vclji.style.display == "block" && !VERSECLICK.LoadedRefs[vclj1]) {
        VERSECLICK.LoadedRefs[vclj1] = true;
        var url = vcjl + "getvcscript3.php?div=" + encodeURIComponent(vclj1) + "&p=" + encodeURIComponent(vcljl);
        var vclii = document.createElement("script");
        vclii.setAttribute("src", url);
        vclii.setAttribute("type", "text/javascript");
        document.body.appendChild(vclii);
    }
};
VERSECLICK.SetBibleDivPos = function(vclji) {
    var vclIj = 0;
    var vclIi = 0;
    var vcliI = 0;
    var vcjj = 0;
    var vcli1 = vclji.relativeElementForPosition;
    vclji.style.left = "-999px";
    vclji.style.display = "block";
    vclji.style.position = "fixed";
    if (vcli1) {
        var vcIij = vcli1.getBoundingClientRect();
        vclIi = vcIij.bottom;
        vclIj = vcIij.left;
        var vclij = window.pageYOffset || document.body.scrollTop || (document.body.parentElement ? document.body.parentElement.scrollTop : 0);
        var vcIli = window.innerHeight || (document.body.parentElement ? document.body.parentElement.clientHeight : 500);
        var vcII1 = window.innerWidth || document.body.clientWidth;
        if (vclIj + vclji.offsetWidth > vcII1 - 30) {
            vclIj = vcII1 - vclji.offsetWidth - 31;
            if (vclIj < 0) vclIj = 0;
        }
        vcliI = 2;
        if (vclIi + vcliI + vclji.offsetHeight > vcIli) {
            vcjj = -vcIij.height - 2 - vclji.offsetHeight;
            if (vclIi + vcjj >= 0) vcliI = vcjj;
        }
        vclIi += vcliI;
        vclji.style.left = vclIj + "px";
        vclji.style.top = vclIi + "px";
    }
};
VERSECLICK.vcIlj = function(vcIIj, vcIi1, vcIii, vcIiI, vcli1) {
    var vcIIi;
    var vcIil;
    vcIil = "VCSCRIPTURE_" + vcIIj.replace(/ +/gi, "_") + vcIi1 + "." + vcIii;
    if (vcIiI) vcIil += "-" + vcIiI;
    vcIIi = document.getElementById(vcIil);
    if (!vcIIi) {
        VERSECLICK.LoadedRefs[vcIil] = false;
        vcIIi = document.createElement("div");
        vcIIi.setAttribute("id", vcIil);
        vcIIi.className = "VerseClickPopupContainer";
        vcIIi.style.display = "none";
        vcIIi.style.textAlign = "left";
        vcIIi.style.position = "absolute";
        vcIIi.style.zIndex = "99999";
        vcIIi.innerHTML = '<div class="VerseClickDefaultHeaderText"><div class="vcPopupHeaderText"><b>Loading...</b></div></div>';
        document.body.appendChild(vcIIi);
    }
    vcIIi.relativeElementForPosition = vcli1;
    return vcIIi;
};
VERSECLICK.vcIII = function(vcIIi) {
    if (!vcIIi) vcIIi = window.event;
    var vcI11 = vcIIi.target || vcIIi.srcElement;
    var vcI1l = VERSECLICK.vcIlj(vcI11.vcRefBook, vcI11.vcRefChap, vcI11.vcRefVerse, vcI11.vcRefVerseEnd, vcI11);
    if (vcI1l) {
        VERSECLICK.SetBibleDivPos(vcI1l);
        setTimeout("VERSECLICK.LoadBibleData('" + vcI1l.id + "')", 200);
    }
};
VERSECLICK.vcI1I = function(vcIIi) {
    if (!vcIIi) vcIIi = window.event;
    var vcI11 = vcIIi.target || vcIIi.srcElement;
    var vcI1l = VERSECLICK.vcIlj(vcI11.vcRefBook, vcI11.vcRefChap, vcI11.vcRefVerse, vcI11.vcRefVerseEnd, vcI11);
    if (vcI1l) vcI1l.style.display = "none";
};
VERSECLICK.vcji = function(vcIIi) {
    if (!vcIIi) vcIIi = window.event;
    var vcI11 = vcIIi.target || vcIIi.srcElement;
    vcIIi.preventDefault();
    vcI11.click();
};
VERSECLICK.vcI1j = function(vcI1i, vclII, vcIlI, vclI1, vcl1j, vciI, vcII) {
    var vcIj;
    var vci1;
    var vcil;
    var vcI1 = "";
    var vcIi;
    var vcIl = "";
    vcIi = vcIlI.length;
    vcil = 0;
    if (vcil = VERSECLICK.vcljj.exec(vcIlI)) {
        vclII += vcil[1] || "";
        vcIlI = vcil[2];
        vcI1 = vcil[3] || "";
        vcIi = vcIlI.length + vcI1.length;
    }
    if (vclII) {
        vcIj = document.createTextNode(vclII);
        vcI1i.parentNode.insertBefore(vcIj, vcI1i);
        vcI1i.nodeValue = vcI1i.nodeValue.substring(vclII.length);
    }
    vcIj = document.createTextNode(vcIlI);
    vci1 = document.createElement("a");
    vcIl = vcjl + "gobible.php?p=" + vclI1 + "_" + vcl1j + "." + vciI;
    if (vcII) vcIl += "-" + vcII;
    vci1.href = encodeURI(vcIl);
    vci1.className = "vcVerseLink";
    vci1.vcRefBook = vclI1;
    vci1.vcRefChap = vcl1j;
    vci1.vcRefVerse = vciI;
    vci1.vcRefVerseEnd = vcII;
    vci1.target = "_blank";
    vci1.rel = "noopener";
    vci1.appendChild(vcIj);
    if (vci1.addEventListener) {
        vci1.addEventListener("touchend", VERSECLICK.vcji, false);
        vci1.addEventListener("mouseover", VERSECLICK.vcIII, false);
        vci1.addEventListener("mouseout", VERSECLICK.vcI1I, false);
    } else if (vci1.attachEvent) {
        vci1.attachEvent("onmouseover", VERSECLICK.vcIII);
        vci1.attachEvent("onmouseout", VERSECLICK.vcI1I);
    }
    vcI1i.parentNode.insertBefore(vci1, vcI1i);
    if (vcI1) {
        vcIj = document.createTextNode(vcI1);
        vcI1i.parentNode.insertBefore(vcIj, vcI1i);
    }
    vcI1i.nodeValue = vcI1i.nodeValue.substring(vcIi);
};
VERSECLICK.vcli = function(vcI1i) {
    var vcj = false;
    var vci;
    var i;
    var m;
    var vcll;
    var vclI;
    var vcl1;
    var vclII;
    var vclj;
    var vcii;
    var vcl1j;
    var vciI;
    var vcII;
    var vcll1;
    var vcij;
    if (vcI1i) {
        var tagName = vcI1i.tagName;
        if (tagName) vcj = VERSECLICK.vcljI[tagName.toLowerCase()] === 1;
        if (!vcj) {
            if (vcI1i.nodeType === 3) {
                vcll = 0;
                vclI = 0;
                while(m = VERSECLICK.vcIll.exec(vcI1i.nodeValue)){
                    vclII = RegExp.leftContext;
                    vclj = m[2];
                    vcll = 0;
                    vclI = 0;
                    vcl1 = m[1];
                    vcll1 = m[0].substring(0, m[0].length - m[2].length);
                    vcii = true;
                    vcij = VERSECLICK.vcIl1.exec("");
                    while(vcii && (vcij = VERSECLICK.vcIl1.exec(vclj))){
                        vcl1j = 0;
                        vciI = 0;
                        vcII = 0;
                        vcll1 += vcij[0];
                        if (vcij[1]) {
                            if (vcll === 0) {
                                vcll = vcij[1];
                                vclI = 0;
                            } else if (vclI === 0) vclI = vcij[1];
                            else {
                                vcl1j = vcll;
                                vciI = vclI;
                                vcII = vcij[1];
                            }
                        } else if (vcij[2]) switch(vcij[2]){
                            case "\u2013":
                            case "-":
                                if (!(vcll && vclI)) vcii = false;
                                break;
                            case ".":
                            case ":":
                                if (!vcll || vcll && vclI) vcii = false;
                                break;
                            case ",":
                                if (!(vcll && vclI)) vcii = false;
                                else {
                                    vcl1j = vcll;
                                    vciI = vclI;
                                    vclI = 0;
                                }
                                break;
                            case " ":
                                if (vcll && vclI) {
                                    vcl1j = vcll;
                                    vciI = vclI;
                                    vcll = 0;
                                    vclI = 0;
                                }
                                break;
                            case ";":
                                if (vcll && vclI) {
                                    vcl1j = vcll;
                                    vciI = vclI;
                                    vcll = 0;
                                    vclI = 0;
                                }
                                if (vcll) vcii = false;
                            default:
                        }
                        else {
                            vcll = 0;
                            vcii = false;
                        }
                        if (vcl1j && vciI && vcll1) {
                            VERSECLICK.vcI1j(vcI1i, vclII, vcll1, vcl1, vcl1j, vciI, vcII);
                            VERSECLICK.vcI += 1;
                            vcll1 = "";
                            vclII = "";
                        }
                    }
                    if (vcll && vclI && vcll1) {
                        VERSECLICK.vcI1j(vcI1i, vclII, vcll1, vcl1, vcll, vclI, 0);
                        VERSECLICK.vcI += 1;
                        vcll1 = "";
                        vclII = "";
                    }
                }
            }
            vci = vcI1i.childNodes;
            for(i = 0; i < vci.length; i += 1)VERSECLICK.vcli(vci[i]);
        }
    }
};
VERSECLICK.vcl1I = function() {
    var vclli = document.createElement("style");
    try {
        var vcl1l = document.createTextNode(".VerseClickPopupContainer {-webkit-box-shadow: 0px 0px 5px rgba(0, 0, 0, 1); -moz-box-shadow: 0px 0px 5px rgba(0, 0, 0, 1); box-shadow: 0px 0px 5px rgba(0, 0, 0, 1); -webkit-border-radius: 5px; -moz-border-radius: 5px; border-radius: 5px; border:1px solid #000; padding:0px; width:310px; margin:0px; font-size:12px; font-family:Verdana, Geneva, sans-serif; font-weight:normal; color:#000; overflow:hidden; } .VerseClickPopupContainer b{ font-weight:700; } .VerseClickDefaultOuter { background-color:#000; color:#999; } .VerseClickDefaultVerseText { background-color:#FFF; color:#000; } .VerseClickDefaultVerseText div {margin:0;Padding:1em;} .VerseClickDefaultHeaderText {background-color:#EEE; color:#000;} .VerseClickDefaultHeaderText div {margin:0; padding:1em;}");
        vclli.appendChild(vcl1l);
        document.body.appendChild(vclli);
    } catch (vcllI) {
        var vclll = document.createElement("link");
        vclll.setAttribute("rel", "stylesheet");
        vclll.setAttribute("type", "text/css");
        vclll.setAttribute("href", vcjl + "verseclick_js.css");
        document.getElementsByTagName("head")[0].appendChild(vclll);
    }
};
VERSECLICK.vcllj = function() {
    VERSECLICK.vcl1I();
    VERSECLICK.vcli(document.body);
};
VERSECLICK.vcI = 0;
VERSECLICK.LoadedRefs = [];
VERSECLICK.vcljI = {
    a: 1,
    h1: 1,
    h2: 1,
    h3: 1,
    h4: 1
};
VERSECLICK.vcljj = /^([-–â€”,.;: ]+)?(.*?)([-–â€”,.;: ]+)?$/i;
VERSECLICK.vcIl1 = /(\d{1,3}\b)|([-–â€”,.;: ])/gi;
VERSECLICK.vcIll = /\b((?:1 +ch)(?:|r|ro|ron|roni|ronic|ronicl|ronicle|ronicles)|(?:1 +co)(?:|r|ri|rin|rint|rinth|rinthi|rinthia|rinthian|rinthians)|(?:1 +jn)|(?:1 +jo)(?:|h|hn)|(?:1 +kgs)|(?:1 +ki)(?:|n|ng|ngs)|(?:1 +pe)(?:|t|te|ter)|(?:1 +sa)(?:|m|mu|mue|muel)|(?:1 +th)(?:|e|es|ess|essa|essal|essalo|essalon|essaloni|essalonia|essalonian|essalonians)|(?:1 +ti)(?:|m|mo|mot|moth|mothy)|(?:1c)(?:|h|hr|hro|hron|hroni|hronic|hronicl|hronicle|hronicles|o|or|ori|orin|orint|orinth|orinthi|orinthia|orinthian|orinthians)|(?:1j)(?:|n|o|oh|ohn)|(?:1k)(?:|gs|i|in|ing|ings)|(?:1p)(?:|e|et|ete|eter)|(?:1s)(?:|a|am|amu|amue|amuel|t +ch|t +chr|t +chro|t +chron|t +chroni|t +chronic|t +chronicl|t +chronicle|t +chronicles|t +co|t +cor|t +cori|t +corin|t +corint|t +corinth|t +corinthi|t +corinthia|t +corinthian|t +corinthians|t +jo|t +joh|t +john|t +ki|t +kin|t +king|t +kings|t +pe|t +pet|t +pete|t +peter|t +sa|t +sam|t +samu|t +samue|t +samuel|t +th|t +the|t +thes|t +thess|t +thessa|t +thessal|t +thessalo|t +thessalon|t +thessaloni|t +thessalonia|t +thessalonian|t +thessalonians|t +ti|t +tim|t +timo|t +timot|t +timoth|t +timothy)|(?:1t)(?:|h|he|hes|hess|hessa|hessal|hessalo|hessalon|hessaloni|hessalonia|hessalonian|hessalonians|i|im|imo|imot|imoth|imothy)|(?:2 +ch)(?:|r|ro|ron|roni|ronic|ronicl|ronicle|ronicles)|(?:2 +co)(?:|r|ri|rin|rint|rinth|rinthi|rinthia|rinthian|rinthians)|(?:2 +jn)|(?:2 +jo)(?:|h|hn)|(?:2 +kgs)|(?:2 +ki)(?:|n|ng|ngs)|(?:2 +pe)(?:|t|te|ter)|(?:2 +sa)(?:|m|mu|mue|muel)|(?:2 +th)(?:|e|es|ess|essa|essal|essalo|essalon|essaloni|essalonia|essalonian|essalonians)|(?:2 +ti)(?:|m|mo|mot|moth|mothy)|(?:2c)(?:|h|hr|hro|hron|hroni|hronic|hronicl|hronicle|hronicles|o|or|ori|orin|orint|orinth|orinthi|orinthia|orinthian|orinthians)|(?:2j)(?:|n|o|oh|ohn)|(?:2k)(?:|gs|i|in|ing|ings)|(?:2nd +ch)(?:|r|ro|ron|roni|ronic|ronicl|ronicle|ronicles)|(?:2nd +co)(?:|r|ri|rin|rint|rinth|rinthi|rinthia|rinthian|rinthians)|(?:2nd +jo)(?:|h|hn)|(?:2nd +ki)(?:|n|ng|ngs)|(?:2nd +pe)(?:|t|te|ter)|(?:2nd +sa)(?:|m|mu|mue|muel)|(?:2nd +th)(?:|e|es|ess|essa|essal|essalo|essalon|essaloni|essalonia|essalonian|essalonians)|(?:2nd +ti)(?:|m|mo|mot|moth|mothy)|(?:2p)(?:|e|et|ete|eter)|(?:2s)(?:|a|am|amu|amue|amuel)|(?:2t)(?:|h|he|hes|hess|hessa|hessal|hessalo|hessalon|hessaloni|hessalonia|hessalonian|hessalonians|i|im|imo|imot|imoth|imothy)|(?:3 +jn)|(?:3 +jo)(?:|h|hn)|(?:3j)(?:|n|o|oh|ohn)|(?:3rd +jo)(?:|h|hn)|(?:ac)(?:|t|ts)|(?:am)(?:|o|os)|(?:ca)(?:|n|nt|nti|ntic|nticl|nticle|nticles)|(?:co)(?:|l|lo|los|loss|lossi|lossia|lossian|lossians)|(?:ct)|(?:da)(?:|n|ni|nie|niel)|(?:de)(?:|u|ut|ute|uter|utero|uteron|uterono|uteronom|uteronomy)|(?:dn)|(?:dt)|(?:ec)(?:|c|cl|cle|cles|clesi|clesia|clesias|clesiast|clesiaste|clesiastes)|(?:ep)(?:|h|he|hes|hesi|hesia|hesian|hesians)|(?:es)(?:|t|th|the|ther)|(?:ex)(?:|o|od|odu|odus)|(?:ez)(?:|e|ek|eki|ekie|ekiel|k|r|ra)|(?:ga)(?:|l|la|lat|lati|latia|latian|latians)|(?:ge)(?:|n|ne|nes|nesi|nesis)|(?:gn)|(?:ha)(?:|b|ba|bak|bakk|bakku|bakkuk|g|gg|gga|ggai)|(?:hb)|(?:he)(?:|b|br|bre|brew|brews)|(?:ho)(?:|s|se|sea)|(?:i +ch)(?:|r|ro|ron|roni|ronic|ronicl|ronicle|ronicles)|(?:i +co)(?:|r|ri|rin|rint|rinth|rinthi|rinthia|rinthian|rinthians)|(?:i +jo)(?:|h|hn)|(?:i +ki)(?:|n|ng|ngs)|(?:i +pe)(?:|t|te|ter)|(?:i +sa)(?:|m|mu|mue|muel)|(?:i +th)(?:|e|es|ess|essa|essal|essalo|essalon|essaloni|essalonia|essalonian|essalonians)|(?:i +ti)(?:|m|mo|mot|moth|mothy)|(?:i\. +ch)(?:|r|ro|ron|roni|ronic|ronicl|ronicle|ronicles)|(?:i\. +co)(?:|r|ri|rin|rint|rinth|rinthi|rinthia|rinthian|rinthians)|(?:i\. +jo)(?:|h|hn)|(?:i\. +ki)(?:|n|ng|ngs)|(?:i\. +pe)(?:|t|te|ter)|(?:i\. +sa)(?:|m|mu|mue|muel)|(?:i\. +th)(?:|e|es|ess|essa|essal|essalo|essalon|essaloni|essalonia|essalonian|essalonians)|(?:i\. +ti)(?:|m|mo|mot|moth|mothy)|(?:i\.ch)(?:|r|ro|ron|roni|ronic|ronicl|ronicle|ronicles)|(?:i\.co)(?:|r|ri|rin|rint|rinth|rinthi|rinthia|rinthian|rinthians)|(?:i\.jo)(?:|h|hn)|(?:i\.ki)(?:|n|ng|ngs)|(?:i\.pe)(?:|t|te|ter)|(?:i\.sa)(?:|m|mu|mue|muel)|(?:i\.th)(?:|e|es|ess|essa|essal|essalo|essalon|essaloni|essalonia|essalonian|essalonians)|(?:i\.ti)(?:|m|mo|mot|moth|mothy)|(?:ii +ch)(?:|r|ro|ron|roni|ronic|ronicl|ronicle|ronicles)|(?:ii +co)(?:|r|ri|rin|rint|rinth|rinthi|rinthia|rinthian|rinthians)|(?:ii +jo)(?:|h|hn)|(?:ii +ki)(?:|n|ng|ngs)|(?:ii +pe)(?:|t|te|ter)|(?:ii +sa)(?:|m|mu|mue|muel)|(?:ii +th)(?:|e|es|ess|essa|essal|essalo|essalon|essaloni|essalonia|essalonian|essalonians)|(?:ii +ti)(?:|m|mo|mot|moth|mothy)|(?:ii\. +ch)(?:|r|ro|ron|roni|ronic|ronicl|ronicle|ronicles)|(?:ii\. +co)(?:|r|ri|rin|rint|rinth|rinthi|rinthia|rinthian|rinthians)|(?:ii\. +jo)(?:|h|hn)|(?:ii\. +ki)(?:|n|ng|ngs)|(?:ii\. +pe)(?:|t|te|ter)|(?:ii\. +sa)(?:|m|mu|mue|muel)|(?:ii\. +th)(?:|e|es|ess|essa|essal|essalo|essalon|essaloni|essalonia|essalonian|essalonians)|(?:ii\. +ti)(?:|m|mo|mot|moth|mothy)|(?:ii\.ch)(?:|r|ro|ron|roni|ronic|ronicl|ronicle|ronicles)|(?:ii\.co)(?:|r|ri|rin|rint|rinth|rinthi|rinthia|rinthian|rinthians)|(?:ii\.jo)(?:|h|hn)|(?:ii\.ki)(?:|n|ng|ngs)|(?:ii\.pe)(?:|t|te|ter)|(?:ii\.sa)(?:|m|mu|mue|muel)|(?:ii\.th)(?:|e|es|ess|essa|essal|essalo|essalon|essaloni|essalonia|essalonian|essalonians)|(?:ii\.ti)(?:|m|mo|mot|moth|mothy)|(?:iii +jo)(?:|h|hn)|(?:iii\. +jo)(?:|h|hn)|(?:iii\.jo)(?:|h|hn)|(?:is)(?:|a|ai|aia|aiah)|(?:ja)(?:|m|me|mes|s)|(?:jb)|(?:jde)|(?:jdg)|(?:je)(?:|r|re|rem|remi|remia|remiah)|(?:jg)|(?:jn)(?:|a|h)|(?:jo)(?:|b|e|el|h|hn|n|na|nah|s|sh|shu|shua)|(?:ju)(?:|d|de|dg|dge|dges)|(?:la)(?:|m|me|men|ment|menta|mentat|mentati|mentatio|mentation|mentations)|(?:le)(?:|v|vi|vit|viti|vitic|viticu|viticus)|(?:lk)|(?:lu)(?:|k|ke)|(?:ma)(?:|l|la|lac|lach|lachi|r|rk|t|tt|tth|tthe|tthew)|(?:mi)(?:|c|ca|cah)|(?:mk)|(?:mr)|(?:mt)(?:|t)|(?:na)(?:|h|hu|hum)|(?:ne)(?:|h|he|hem|hemi|hemia|hemiah)|(?:nu)(?:|m|mb|mbe|mber|mbers)|(?:ob)(?:|a|ad|adi|adia|adiah)|(?:ph)(?:|i|il|ile|ilem|ilemo|ilemon|ili|ilip|ilipp|ilippi|ilippia|ilippian|ilippians|lm|m|p)|(?:pr)(?:|o|ov|ove|over|overb|overbs)|(?:ps)(?:|a|al|alm|alms|s)|(?:re)(?:|v|ve|vel|vela|velat|velati|velatio|velation)|(?:ro)(?:|m|ma|man|mans)|(?:rth)|(?:ru)(?:|t|th)|(?:rv)|(?:so)(?:|l|lo|lom|lomo|lomon|n|ng|ng +o|ng +of|ng +of +s|ng +of +so|ng +of +sol|ng +of +solo|ng +of +solom|ng +of +solomo|ng +of +solomon|ng +of +songs|s)|(?:ti)(?:|t|tu|tus)|(?:tts)|(?:zc)|(?:ze)(?:|c|ch|cha|char|chari|charia|chariah|p|ph|pha|phan|phani|phania|phaniah)|(?:zp))[._]?(?![a-z])\s*((?:(?:\d{1,3})\b(?:[\-–â€”.,:; ] *(?=\d))?)+)/gi;
function vcl11(vcj1) {
    var vcl1i = window.onload;
    if (typeof window.onload !== "function") window.onload = vcj1;
    else window.onload = function() {
        if (vcl1i) vcl1i();
        vcj1();
    };
}
vcl11(VERSECLICK.vcllj);

//# sourceMappingURL=0bd8e6cd.js.map
